export type QrfyIdsInput = number[] | string | null | undefined;

const invalidMessage =
  "Saisissez des ids QRFY entiers positifs, séparés par des virgules";

export const parseQrfyIds = (value: QrfyIdsInput): number[] => {
  if (
    value === null ||
    value === undefined ||
    (typeof value === "string" && value.trim() === "")
  ) {
    return [];
  }

  const tokens = Array.isArray(value)
    ? value
    : value.split(",").map((token) => token.trim());
  const ids = tokens.map((token) => {
    if (typeof token === "number") {
      if (Number.isSafeInteger(token) && token > 0) return token;
      throw new Error(invalidMessage);
    }
    if (!/^[1-9]\d*$/.test(token)) throw new Error(invalidMessage);
    const id = Number(token);
    if (!Number.isSafeInteger(id)) throw new Error(invalidMessage);
    return id;
  });

  return [...new Set(ids)].sort((a, b) => a - b);
};

export const formatQrfyIds = (value: QrfyIdsInput): string =>
  Array.isArray(value) ? value.join(", ") : (value ?? "");

export const validateQrfyIds = (value: QrfyIdsInput): true | string => {
  try {
    parseQrfyIds(value);
    return true;
  } catch {
    return invalidMessage;
  }
};

export type LaunchDateInput = string | null | undefined;

const launchDateError = "Saisissez une date de lancement valide";
const dateOnlyPattern = /^\d{4}-\d{2}-\d{2}$/;

export const formatLaunchDate = (value: LaunchDateInput): string =>
  value ? value.slice(0, 10) : "";

export const parseLaunchDate = (value: LaunchDateInput): string | null => {
  const date = formatLaunchDate(value);
  if (!date) return null;
  if (!dateOnlyPattern.test(date)) throw new Error(launchDateError);
  const parsed = new Date(`${date}T00:00:00.000Z`);
  if (
    Number.isNaN(parsed.getTime()) ||
    parsed.toISOString().slice(0, 10) !== date
  ) {
    throw new Error(launchDateError);
  }
  return date;
};

export const validateLaunchDate = (value: LaunchDateInput): true | string => {
  try {
    parseLaunchDate(value);
    return true;
  } catch {
    return launchDateError;
  }
};
